import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCommentDots, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { ChatWindowComponent } from '../chat-window/chat-window.component';

@Component({
  selector: 'app-chatbox',
  templateUrl: './chatbox.component.html',
  styleUrls: ['./chatbox.component.scss'],
  standalone: true,
  imports: [CommonModule, ChatWindowComponent, FaIconComponent],
})
export class ChatboxComponent {
  isChatOpen = false;
  faTimes = faTimes;
  faCommentDots = faCommentDots;

  toggleChat(): void {
    this.isChatOpen = !this.isChatOpen;
  }
}
